import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITableData } from '../models/table';
import { ICreateGroupData, IPlanogramListItem } from '../models/planogramGroups';

const ROOT_URL: string = '/api/v1/planogram-groups/';

@Injectable({
	providedIn: 'root'
})
export class PlanogramGroupsService {
	constructor(private http: HttpClient) {}

	onCreate(params: ICreateGroupData): Observable<{ id: number }> {
		return this.http.post<{ id: number }>(ROOT_URL, params);
	}

	onDelete(id: number): Observable<void> {
		return this.http.delete<void>(`${ROOT_URL}${id}/`);
	}

	onUpdate(id: number, params: ICreateGroupData): Observable<void> {
		return this.http.put<void>(`${ROOT_URL}${id}/`, params);
	}

	getPlanogramsList(params: any = {}): Observable<ITableData<IPlanogramListItem>> {
		return this.http.get<ITableData<IPlanogramListItem>>('/api/v1/simplified-planograms-table/', { params });
	}

	getItem(id: number): Observable<any> {
		return this.http.get<any>(`${ROOT_URL}${id}/`);
	}
}
